module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_1.675928ab.png";